import '../../../scss/bakery/components/production-fable.scss'

import { Button, Card, Grid, GridItem } from '@sainsburys-tech/fable'
import React from 'react'

import ProductionPlanningButton from '../../../common/components/ProductionPlanningButton'
import { MixStageEnum } from '../../enums/MixStageEnum'
import { IMix } from '../../types/IMix'
import sortMixes from '../../utils/sortMixes'
import WaveMixCardTitle from './WaveMixCardTitle'

interface IWaveMixProps {
  mixesForWave: IMix[]
  handleMixActions: (mix: IMix, nextStatus?: MixStageEnum) => Promise<void>
}

const WaveMixCard = (props: IWaveMixProps) => {
  const isMixInProgress = (mix: IMix) =>
    mix.mixStatusStageId === (MixStageEnum.InProgress as number)
  const isMixInPending = (mix: IMix) =>
    mix.mixStatusStageId === (MixStageEnum.Pending as number)
  const getPendingButtonText = (mix: IMix) =>
    mix.isReadonly === true
      ? 'View'
      : mix.enabled !== true
        ? 'Preview wave'
        : 'Start'
  const isMixCompleted = (mix: IMix) =>
    mix.mixStatusStageId === (MixStageEnum.Completed as number)

  const getMixesForWave = () => {
    const mixes = sortMixes(props.mixesForWave).map((mix) => (
      <div
        className='bakery-card bakery-shadow-sm bakery-mb-4 bakery-hover-shadow bakery-rounded'
        data-testid='mix-card'
        key={mix.mixId}
        id={`MixId_${mix.mixId}`}
      >
        {isMixInProgress(mix) === true && <div />}
        <Card
          orientation='vertical'
          className='bakery-rounded'
          style={{
            backgroundColor: 'var(--fable-color-background-secondary-default)',
          }}
        >
          <WaveMixCardTitle
            plannerGroupName={
              mix.plannerGroup !== null ? mix.plannerGroup.plannerGroupName : ''
            }
            ovenSettingDetail={mix.ovenSettingDetail}
          />
          {isMixInProgress(mix) === true && (
            <Grid cols={12} colSize='auto' gap='md'>
              <GridItem colSpan={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                <Button
                  style={{
                    backgroundColor:
                      'var(--fable-color-background-secondary-default)',
                  }}
                  testid='mix-button-view-inprogress'
                  isFullWidth
                  onClick={() => props.handleMixActions(mix)}
                  variant='secondary'
                >
                  View
                </Button>
              </GridItem>
              <GridItem colSpan={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                <ProductionPlanningButton
                  testid='mix-button-complete'
                  isFullWidth={true}
                  handler={() =>
                    props.handleMixActions(mix, MixStageEnum.InProgress)
                  }
                >
                  Complete
                </ProductionPlanningButton>
              </GridItem>
            </Grid>
          )}
          {isMixInPending(mix) === true && (
            <Button
              style={{
                backgroundColor:
                  'var(--fable-color-background-secondary-default)',
              }}
              variant='secondary'
              testid='mix-button-start'
              disabled={mix.plan.requiresMixRefresh}
              isFullWidth
              onClick={() => props.handleMixActions(mix)}
            >
              {getPendingButtonText(mix)}
            </Button>
          )}
          {isMixCompleted(mix) === true && (
            <Grid cols={12} colSize='auto' gap='md'>
              <GridItem colSpan={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                <Button
                  style={{
                    backgroundColor:
                      'var(--fable-color-background-secondary-default)',
                  }}
                  testid='mix-button-view-completed'
                  isFullWidth
                  onClick={() => props.handleMixActions(mix)}
                  variant='secondary'
                >
                  View
                </Button>
              </GridItem>
            </Grid>
          )}
        </Card>
      </div>
    ))
    return <div>{mixes}</div>
  }

  return <div>{getMixesForWave()}</div>
}

export default WaveMixCard
